// @ts-ignore
import { orgAxios } from '../api/axios';

export const ROMPService = {
  getROMPData,
};

/**
 * Retrieves organization information from the ROMP API by organization ID
 *
 * @param body - Object containing organizationId
 * @returns Promise that resolves to the organization data
 */
async function getROMPData(body: { organizationId: string }) {
  // @ts-ignore
  return await orgAxios.get(`/romp/organizationId`, {
    params: { organizationId: body.organizationId },
  });
}
